import { formId as cognitiveFormId, formTitle as cognitiveFormTitle } from '../questions-cognitive-function';

export const selectableForms = [
  { value: cognitiveFormId, label: cognitiveFormTitle, path: 'questions-cognitive-function' },
];
